export const permissionTnpType = {
    LOAD_PERMISSIONS_TNP_DATA_START : "LOAD_PERMISSIONS_TNP_DATA_START",
    SET_PERMISSIONS_TNP_SUCCESS : "SET_PERMISSIONS_TNP_SUCCESS",
    SET_PERMISSIONS_TNP_ERROR : "SET_PERMISSIONS_TNP_ERROR",
}